module.exports = __webpack_public_path__ + "img/054-canary-islands.bcba29fc.svg";